/* global $ */
/* eslint no-unused-vars: 0 */

import { setCookie } from '../helpers/cookies';

const scrollEffectDelay = 10; // delay any scroll events by this many MS
const $topNav = $('.main-header');
const $html = $('html');
let topNavHeight = $topNav.innerHeight(); // eslint-disable-line no-unused-vars
const $alertBar = $.$body.find('.alert-bar__top');
let alertBarHeight = 0;

if ($alertBar.get(0)) {
	alertBarHeight = $alertBar.get(0).scrollHeight;
}

setTimeout(() => {
	if (
		$html.hasClass('ok-to-alert') ||
		$html.hasClass('ok-to-alert__footer')
	) {
		$.$body.on('click', '.alert-bar__close', (e) => {
			e.preventDefault();
			const $alert = $(e.target).closest('.alert-bar');
			const {
				// isCookied,
				modifier = '',
				cookievalue,
				expires,
			} = $alert.data();
			if (!modifier) {
				alertBarHeight = 0;
				$topNav.removeClass('is-sticky'); // remove is-sticky on close
			}
			$alert.slideToggle('fast', () => {
				$alert.prop('hidden', true);
				topNavHeight = $topNav.innerHeight();
				$html.removeClass(`ok-to-alert ok-to-alert${modifier}`); // remove ok-to-alert on close
			});

			// set the cookie, even if it won't be used
			setCookie(
				`alertbar${modifier}_clicked`,
				cookievalue || 'value',
				expires || 7
			);
		});
	}
}, 1);
